import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  reset() {
    const url = new URL(window.location);
    window.location = url.href.replace(url.search, "");
  }
}
